import axios from 'axios'
import utils from '../business-common'
import { Dialog, Toast } from 'vant'
let proposal = [
  '/proposal/proposal/list',
  '/proposal/proposal/toInsurance',
  '/proposal/proposal/info',
  '/proposal/proposal/demo',
  '/proposal/proposal/saveOrUpdateProposal',
  '/proposal/proposal/updateInsured',
  '/proposal/file/getFile',
  '/proposal/proposal/deleteProposal',
] //计划书
let sale = ['/sale/order/orderList', '/originLink', '/sale/order/saveOrUpdateOrderInfo'] //在线投保
let agentEnter = [
  '/agent/enter/share',
  '/agent/enter/query',
  '/agent/enter/saveOrUpdateInfo',
  '/agent/enter/queryAll',
  '/agent/enter/getImpart',
  '/agent/agreement/query',
  '/agent/agreement/signAgreement',
  '/agent/enter/query',
  '/agent/agreement/getAgreementDetail',
] //入司
let claims = [
  `/claim/claimApply/progress`,
  `/claim/claimApply/progressDetail`,
  `/claim/claimReport/history`,
  `/claim/claimApply/apply`,
  `/edor/customer/customerList`,
  `/edor/customer/customerInfo`,
  `/claim/claimApply/query`,
  `/claim/claimApply/delete`,
]
let whiteList = ['/customer/agent/getCustomersList', ...proposal, ...sale, ...agentEnter, ...claims]

// 创建axios实例
const service = axios.create({
  timeout: 66666666, // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  (config) => {
    let relativePath = config.url && config.url.split('v1')[1]
    if (whiteList.includes(relativePath)) {
      Toast.loading({
        duration: 2000, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: 'spinner',
        message: '加载中……',
      })
    }
    // config.headers['token'] = window.localStorage.getItem('token')
    let urlStr = config.url
    // 检测请求的是否是json文件
    if (!urlStr.includes('.json')) {
      if (window.localStorage.getItem('ctoken')) {
        config.headers['token'] = utils.getCookie('token')
        config.headers['ctoken'] = window.localStorage.getItem('ctoken')
        config.headers['REQUEST_SOURCE'] = 'BC_QY'
        config.headers['identification'] = 'Z0003'
      } else {
        config.headers['token'] = utils.getCookie('token')
        config.headers['REQUEST_SOURCE'] = 'BC_QY'
        config.headers['identification'] = 'Z0003'
      }
    }
    return config
  },
  (error) => {
    // Do something with request error
    Promise.reject(error)
  }
)

// respone拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data
    // Toast.clear()
    if (res.code != 0) {
      if (res.code == 10001 || res.code == 10002) {
        Dialog.confirm({
          confirmButtonText: '重新登录',
          message: '您的登录信息已失效，请重新登录！或点击取消继续留在该页面',
        }).then(() => {
          //eslint-disable-next-line
          // 原生跳转
          // EWebBridge.webCallAppInJs('login')
          window.localStorage.clear()
          window.sessionStorage.clear()
          utils.delCookie('token')
          window.location.href = window.location.protocol + '/app/h5/#/'
        })
      }
      // else if(res.code == 20001){
      //   Dialog.alert({
      //     title: '提示',
      //     message: '链接已失效，请联系代理人'
      //   }).then(() => {
      //     //eslint-disable-next-line
      //     // 原生跳转
      //     // EWebBridge.webCallAppInJs('login')
      //     utils.delCookie('token')
      //     window.localStorage.removeItem('ctoken')
      //     window.location.href = window.location.protocol + '/app/h5/#/404'
      //   })
      //   // Toast.loading({
      //   //   duration: 0, // 持续展示 toast
      //   //   forbidClick: true, // 禁用背景点击
      //   //   loadingType: 'spinner',
      //   //   icon: 'warn-o',
      //   //   message: '链接已失效'
      //   // })
      // }
      else {
        // Toast.fail(res.msg)
      }
      return Promise.resolve(res)
    } else {
      if (window.localStorage.getItem('isFirstLogin') == 1) {
        window.location.href = window.location.protocol + '/app/h5/#/changePwd?isFirstLogin=1'
      }
      return response.data.content
    }
  },
  (error) => {
    Toast.clear()
    console.log('err' + error) // for debug
    //Toast.fail(error.message)
    return Promise.reject(error)
  }
)

export default service
